import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="py-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-search-eye-line text-background-50 text-lg"></i>
              </div>
              <span className="text-xl font-bold text-background-50 font-heading">
                狠狠撸
              </span>
            </Link>
            <p className="text-sm text-background-300 leading-relaxed">
              海量资源一站式极速搜索平台，致力于为您提供最快、最准、最全的资源检索体验。
            </p>
            <div className="flex items-center gap-3 mt-5">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-secondary-800 text-background-300 hover:text-background-50 hover:bg-primary-500 transition-colors" aria-label="微信">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-secondary-800 text-background-300 hover:text-background-50 hover:bg-primary-500 transition-colors" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-secondary-800 text-background-300 hover:text-background-50 hover:bg-primary-500 transition-colors" aria-label="GitHub">
                <i className="ri-github-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-5">热门分类</h4>
            <ul className="flex flex-col gap-3">
              {categories.slice(0, 6).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-300 hover:text-background-50 transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-5">快速链接</h4>
            <ul className="flex flex-col gap-3">
              <li><Link to="/" className="text-sm text-background-300 hover:text-background-50 transition-colors">首页</Link></li>
              <li><Link to="/about" className="text-sm text-background-300 hover:text-background-50 transition-colors">关于我们</Link></li>
              <li><a href="#" className="text-sm text-background-300 hover:text-background-50 transition-colors">使用帮助</a></li>
              <li><a href="#" className="text-sm text-background-300 hover:text-background-50 transition-colors">资源提交</a></li>
              <li><a href="#" className="text-sm text-background-300 hover:text-background-50 transition-colors">用户协议</a></li>
              <li><a href="#" className="text-sm text-background-300 hover:text-background-50 transition-colors">隐私政策</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-5">联系我们</h4>
            <ul className="flex flex-col gap-3">
              <li className="flex items-start gap-2 text-sm text-background-300">
                <i className="ri-mail-line mt-0.5 text-primary-400"></i>
                <span>contact@henhenlu.com</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-background-300">
                <i className="ri-customer-service-line mt-0.5 text-primary-400"></i>
                <span>在线客服：工作日 9:00-18:00</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-background-300">
                <i className="ri-map-pin-line mt-0.5 text-primary-400"></i>
                <span>北京市海淀区中关村科技园</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-secondary-800 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-sm text-background-400">
            &copy; 2024 狠狠撸 henhenlu.com 版权所有
          </p>
          <p className="text-sm text-background-400">
            <a href="#" className="hover:text-background-50 transition-colors">京ICP备2024000001号</a>
            <span className="mx-2">|</span>
            <a href="#" className="hover:text-background-50 transition-colors">京公网安备 11010802000001号</a>
          </p>
        </div>
      </div>
    </footer>
  );
}